export default {
    MAP_LOAD: 'tomtom.map.load'
};
